package sarka.design.skoria.ui.theme.support

import androidx.compose.ui.graphics.Color

//Brand Theme — Green & Ash (matches Skoria logo)
val RCPrimary = Color(0xFF00A14B)
val RCOnPrimary = Color(0xFFFFFFFF)
val RCPrimaryContainer = Color(0xFF2E3A32)
val RCOnPrimaryContainer = Color(0xFFC8E6D0)

val RCSecondary = Color(0xFF6B7D71)
val RCOnSecondary = Color(0xFFFFFFFF)
val RCSecondaryContainer = Color(0xFF4B524D)
val RCOnSecondaryContainer = Color(0xFFD4E4DA)
val RCTertiary = Color(0xFF4CAF79)
val RCBackground = Color(0xFF1C1C1C)
val RCSurface = Color(0xFF2D2D2D)
val RCOnBackground = Color(0xFFE8E8E8)
val RCOnSurface = Color(0xFFE0E0E0)
val RCOnSurfaceVariant = Color(0xFFABB8A9)
val RCAccent = Color(0xFFEC7B47)

// Neutrals
val Neutral0 = Color(0xFFFFFFFF)
val Neutral900 = Color(0xFF111827)
